angular.module('zc.zenclerkS')
  .controller('ZcsCampaignEditModalConversionPriceController', ZcsCampaignEditModalConversionPriceController);

ZcsCampaignEditModalConversionPriceController.$inject = ['$scope', '$uibModalInstance', 'ZcsProject', 'currencies', 'project'];
function ZcsCampaignEditModalConversionPriceController($scope, $uibModalInstance, ZcsProject, currencies, project) {
  const vm = this;
  vm.project = project;
  vm.currency = currencies[vm.project.currency];
  vm.close = close;
  vm.profitRateOptions = ZcsProject.PROFIT_RATE_OPTIONS();
  vm.averageConversionPriceOptions = ZcsProject.AVERAGE_CONVERSION_PRICE_OPTIONS(vm.currency);
  vm.setProfitAndConversion = setProfitAndConversion;
  vm.isSaving = false;

  function setProfitAndConversion() {
    vm.isSaving = true;
    ZcsProject.saveProject(vm.project).then(res => {
      vm.project = _.merge(vm.project, res);
    })
      .finally(() => {
        vm.isSaving = false;
        $scope.campaignEditConversionPrice.$setPristine();
        close();
      });
  }

  function close() {
    $uibModalInstance.close();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_conversion_price.controller.js